import React from 'react';

const Pill = (props) => {
  return <span className='pill'>{props.name}</span>;
};

export { Pill as default };
